import { createConsola } from 'consola'

const logger = createConsola().withTag('mm:errors')

interface ErrorMeta {
  request?: unknown
  metaData?: Record<string, unknown>
  severity?: 'info' | 'warning' | 'error'
}

export default defineNuxtPlugin(() => {
  const handle = (error: unknown, meta: ErrorMeta = {}) => {
    logger.error(error, meta)
  }

  return {
    provide: {
      errorHandler: {
        handle,
        handleHttpError: handle,
      },
    },
  }
})
